
let Backend = '';
let Frontend = '';
let host = document.location.hostname;
// Backend = 'http://localhost:8962/';
// Frontend = 'http://localhost:8962/';


Backend = 'https://back.kairaascan.io/';
Frontend = 'https://kairaascan.io/';


export var BackendHost = Backend;
export var FrontendHost = Frontend;

